<template>
  <!-- O esqueleto de cada aba da janela de propriedade (ver o `PropertyTabs`): na Propriedade do
       atributo, à esquerda o que ele É — identidade e tipo — e à direita o comportamento (pedido do
       usuário). Uma coluna só abaixo do `md`. Na largura toda, o que não cabe numa coluna: em cima, as
       caixas dos dois lados de um relacionamento, que espremidas em meia janela quebravam até o par do
       espelho (relato do usuário); embaixo, o cálculo, que ganha espaço para a fórmula (escolha do usuário) -->
  <div class="property-form" :class="{'property-form--sided': !!$slots.side}">
    <div v-if="$slots.top" class="property-form-column property-form-wide"><slot name="top"/></div>
    <div class="property-form-column"><slot name="main"/></div>
    <div v-if="$slots.side" class="property-form-column"><slot name="side"/></div>
    <div v-if="$slots.bottom" class="property-form-column property-form-wide"><slot name="bottom"/></div>
  </div>
</template>

<script lang="ts">
import {Component, Vue, toNative} from 'vue-facing-decorator'

/**
 * As colunas e o ritmo de espaço dos editores de propriedade — atributo e relacionamento —, num lugar
 * só. Antes cada editor tinha o seu `v-container` dentro do cartão (a folga em dobro), colunas fixas de
 * 3/12 que não olhavam a largura, e as caixas de marcar reservando a linha de uma mensagem que nunca
 * vinha: vãos irregulares (relato do usuário: "causa uma certa estranheza").
 *
 * O ritmo: 24px entre seções, 16px entre os campos de uma seção (ver o `property-form-section`).
 */
@Component({name: 'ontos-property-form-layout'})
class PropertyFormLayout extends Vue {
}

export default toNative(PropertyFormLayout)
</script>

<style scoped>
.property-form {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 24px 40px;
}

@media (min-width: 960px) {
  .property-form--sided {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  }
}

.property-form-column {
  display: flex;
  flex-direction: column;
  gap: 24px;
  min-width: 0;
}

.property-form-wide {
  grid-column: 1 / -1;
}

/* Cada seção: o título pequeno e, embaixo, os campos num ritmo só */
.property-form-column :deep(.property-form-section) {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.property-form-column :deep(.property-form-section-title) {
  margin-bottom: -4px;
}

/* Campos lado a lado que quebram linha quando falta espaço — o nome e o identificador, o tipo e o
   subtipo. Alinhados em cima: esticados (o padrão do flex), o campo sem dica crescia até a altura do
   vizinho com dica ("em fórmulas"), e o sublinhado dele descia, abrindo um vão sob o texto (relato do
   usuário) */
.property-form-column :deep(.property-form-row) {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 16px;
}

.property-form-column :deep(.property-form-row > *) {
  flex: 1 1 200px;
  min-width: 0;
}
</style>
